<template>
  <base-section id="testimony" class="trusted-testimony">
    <v-container fluid>
      <div class="slider-shell">
        <div class="slider-header">
          <div class="slider-heading">
            <p class="slider-eyebrow">
              TESTIMONI PESERTA
            </p>
            <h4>Kolaborasi berlandaskan nilai syariah</h4>
          </div>
          <div class="slider-controls" v-if="slides.length > 1">
            <v-btn
              icon
              class="control-button"
              :disabled="slides.length <= 1"
              @click="PrevSlide"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              class="control-button"
              :disabled="slides.length <= 1"
              @click="NextSlide"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="slider-stage">
            <v-slide-group
              v-if="!isMobile"
              v-model="activeIndex"
              class="testimony-slider"
              center-active
            >
            <v-slide-item
              v-for="(slide, index) in slides"
              :key="`${slide.name}-desktop-${index}`"
              :value="index"
            >
              <div class="slider-item">
                <div class="testimonial-card">
                  <div class="card-top">
                    <div class="identity" @click="Zoom(slide.name, slide.src)">
                      <v-avatar size="52">
                        <v-img
                          :src="require(`@/assets/${slide.src}`)"
                          :alt="slide.name"
                          cover
                        />
                      </v-avatar>
                      <div>
                        <p class="name mb-0">{{ slide.name }}</p>
                        <span class="handle">@{{ slide.handle }}</span>
                      </div>
                    </div>
                    <div class="rating-pill">
                      <v-icon small>mdi-star</v-icon>
                      <span>{{ slide.rating }}</span>
                    </div>
                  </div>
                  <div class="quote-mark">
                    <v-icon large>mdi-format-quote-open</v-icon>
                  </div>
                  <p class="quote-text">
                    {{ slide.subtitle }}
                  </p>
                  <!--  <p class="timestamp">{{ slide.timestamp }}</p>-->
                </div>
              </div>
            </v-slide-item>
          </v-slide-group>
            <v-window
              v-else
              v-model="activeIndex"
              class="testimony-window"
              touch
            >
            <v-window-item
              v-for="(slide, index) in slides"
              :key="`${slide.name}-mobile-${index}`"
              :value="index"
            >
              <div class="slider-item">
                <div class="testimonial-card">
                  <div class="card-top">
                    <div class="identity" @click="Zoom(slide.name, slide.src)">
                      <v-avatar size="48">
                        <v-img
                          :src="require(`@/assets/${slide.src}`)"
                          :alt="slide.name"
                          cover
                        />
                      </v-avatar>
                      <div>
                        <p class="name mb-0">{{ slide.name }}</p>
                        <span class="handle">@{{ slide.handle }}</span>
                      </div>
                    </div>
                    <div class="rating-pill">
                      <v-icon small>mdi-star</v-icon>
                      <span>{{ slide.rating }}</span>
                    </div>
                  </div>
                  <div class="quote-mark">
                    <v-icon large>mdi-format-quote-open</v-icon>
                  </div>
                  <p class="quote-text">
                    {{ slide.subtitle }}
                  </p>
                  <p class="timestamp">{{ slide.timestamp }}</p>
                </div>
              </div>
            </v-window-item>
          </v-window>
        </div>
      </div>
    </v-container>
    <v-dialog v-model="zoomin.value" width="500">
      <v-card>
        <v-card-title class="body-2 grey lighten-3 secondary--text">
          {{ zoomin.title }}
        </v-card-title>
        <v-card-text>
          <v-img
            :src="require(`@/assets/${zoomin.src}`)"
            height="100%"
            cover
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </base-section>
</template>

<script>
export default {
  name: "SectionTestimony",
  data() {
    const slides = [
      {
        name: "Bapak H. Husen",
        handle: "husen.takaful",
        rating: "5.0",
        subtitle:
          "Takaful Abror adalah produk yang sangat bagus. Saya sudah menggunakannya selama 2 tahun terakhir; pelayanan klaimnya cepat dan saya bisa memakai bengkel resmi di mana saja.",
        timestamp: "18.00 - June 10, 2027",
        src: "testimoni-bapakhusen-abror.jpeg"
      },
      {
        name: "Ibu Irma",
        handle: "irma.travel",
        rating: "5.0",
        subtitle:
          "Produk Takaful Safari memiliki banyak manfaat dan harganya sangat terjangkau. Customer saya pun tidak keberatan dicover karena proses klaimnya cepat.",
        timestamp: "08.00 - Apr 28, 2027",
        src: "testimoni-ibu-irma-safari.jpeg"
      },
      {
        name: "Rifki Kurniawan",
        handle: "rifki.student",
        rating: "5.0",
        subtitle:
          "Selama masa Covid-19 saya mendapatkan santunan dari Takaful Umum. Bantuan ini membantu kebutuhan saya dan membuat saya semakin percaya pada produk asuransi syariah.",
        timestamp: "11.30 - Jan 16, 2028",
        src: "testimoni-rifki-kecelakaandiri.jpeg"
      },
      {
        name: "Ibu Nidya",
        handle: "nidya.biz",
        rating: "4.8",
        subtitle:
          "Produk Surgaina terjangkau dan bisa mengcover seluruh keluarga dalam satu polis. Manfaatnya lengkap untuk perlindungan kecelakaan diri.",
        timestamp: "15.45 - Oct 05, 2027",
        src: "testimoni-bu-nadia-surgaina.jpeg"
      },
      {
        name: "Ibu Wijaya",
        handle: "wijaya.family",
        rating: "5.0",
        subtitle:
          "Takaful Umum memberi pelayanan cepat dan berbasis digital. Produk Takaful Baituna manfaatnya lengkap serta harganya ramah di kantong.",
        timestamp: "18.00 - Dec 12, 2027",
        src: "testimoni-bapak-alisaaf-baituna.jpeg"
      }
    ];

    return {
      activeIndex: slides.length ? 0 : null,
      zoomin: {
        value: false,
        title: "",
        src: "new-logo.png"
      },

      insight: {
        badge: "Syariah General Insurance",
        title: "Fokus pada rasa tenang dan keberlanjutan usaha",
        description:
          "Kami mendampingi proteksi aset, project, dan keluarga dengan akad transparan serta tata kelola syariah yang kuat.",
        points: [
          "Pendampingan risiko proaktif di setiap cabang",
          "Klaim digital yang dapat dilacak real-time",
          "Panel mitra bengkel dan rumah sakit bersertifikasi"
        ]
      },
      slides
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify ? this.$vuetify.breakpoint.smAndDown : false;
    }
  },
  methods: {
    Zoom(title, src) {
      this.zoomin.value = true;
      this.zoomin.title = title;
      this.zoomin.src = src;
    },
    PrevSlide() {
      if (!this.slides.length) return;
      const currentIndex =
        typeof this.activeIndex === "number" &&
        this.activeIndex >= 0 &&
        this.activeIndex < this.slides.length
          ? this.activeIndex
          : 0;
      const nextIndex =
        currentIndex <= 0 ? this.slides.length - 1 : currentIndex - 1;
      this.activeIndex = nextIndex;
    },
    NextSlide() {
      if (!this.slides.length) return;
      const currentIndex =
        typeof this.activeIndex === "number" &&
        this.activeIndex >= 0 &&
        this.activeIndex < this.slides.length
          ? this.activeIndex
          : 0;
      const nextIndex =
        currentIndex === this.slides.length - 1 ? 0 : currentIndex + 1;
      this.activeIndex = nextIndex;
    }
  }
};
</script>

<style scoped>
.trusted-testimony {
  position: relative;
  padding: 80px 0 !important;

  color: #05223f;
  overflow: hidden;
}

.trusted-testimony::after {
  width: 320px;
  height: 320px;
  background: rgba(255, 138, 0, 0.5);
  bottom: -100px;
  left: -60px;
}

.testimony-surface {
  position: relative;
  z-index: 1;
  border-radius: 48px;
  padding: 48px 36px 56px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(9, 49, 86, 0.1);
  box-shadow: 0 35px 80px rgba(5, 16, 36, 0.15);
  backdrop-filter: blur(8px);
}

.section-intro {
  margin-bottom: 32px;
  align-items: stretch;
  row-gap: 24px;
}

.intro-copy h2 {
  font-weight: 600;
  color: #0b2c5f;
  margin-bottom: 18px;
}

.intro-text {
  color: rgba(5, 34, 63, 0.7);
  max-width: 580px;
  line-height: 1.7;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.24em;
  font-size: 0.78rem;
  color: #14837e;
  margin-bottom: 10px;
}

.trust-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 26px;
}

.trust-metric {
  flex: 1 1 140px;
  padding: 16px 20px;
  border-radius: 20px;
  border: 1px solid rgba(15, 84, 107, 0.15);
  background: rgba(234, 245, 247, 0.9);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.85);
}

.metric-value {
  font-size: 1.9rem;
  font-weight: 600;
  color: #0b2c5f;
  margin-bottom: 4px;
}

.metric-label {
  margin: 0;
  color: rgba(5, 34, 63, 0.6);
}

.insight-panel {
  padding: 28px;
  border-radius: 32px;
  background: linear-gradient(
    160deg,
    rgba(6, 52, 93, 0.1),
    rgba(28, 188, 179, 0.12)
  );
  border: 1px solid rgba(11, 44, 95, 0.12);
  box-shadow: 0 30px 60px rgba(5, 16, 36, 0.1);
}

.insight-badge {
  display: inline-flex;
  padding: 6px 16px;
  border-radius: 999px;
  font-size: 0.75rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #ffffff;
  background: #001f48;
  margin-bottom: 14px;
}

.insight-panel h3 {
  color: #0b2c5f;
  font-weight: 600;
  margin-bottom: 12px;
}

.insight-panel p {
  color: rgba(5, 34, 63, 0.7);
  line-height: 1.6;
}

.insight-list {
  margin: 18px 0 0;
  padding-left: 20px;
  color: rgba(5, 34, 63, 0.85);
  line-height: 1.55;
}

.slider-shell {
  margin-top: 12px;
  padding: 24px;
  border-radius: 32px;
  border: 1px solid rgba(9, 49, 86, 0.08);
  background: rgba(247, 251, 252, 0.9);
}

.slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}

.slider-heading h4 {
  margin: 4px 0 0;
  color: #0b2c5f;
  font-weight: 600;
}

.slider-eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.72rem;
  color: rgba(5, 34, 63, 0.5);
}

.slider-controls {
  display: inline-flex;
  gap: 12px;
}

.control-button {
  background: rgba(13, 77, 117, 0.1) !important;
  color: #0d4d75 !important;
  border: 1px solid rgba(13, 77, 117, 0.25);
  transition: all 0.25s ease;
}

.control-button:not(.v-btn--disabled):hover {
  border-color: rgba(12, 153, 146, 0.5);
  background: rgba(12, 153, 146, 0.12) !important;
}

.slider-stage {
  margin-top: 8px;
}

.testimony-slider {
  width: 100%;
}

::v-deep .testimony-slider .v-slide-group__content {
  gap: 24px;
  padding: 20px 8px 16px;
  justify-content: center;
}

::v-deep .testimony-slider .v-slide-group__prev,
::v-deep .testimony-slider .v-slide-group__next {
  display: none !important;
}

::v-deep .testimony-slider .v-slide-item {
  flex: 0 0 auto;
  display: flex;
}

.testimony-window {
  width: 100%;
}

::v-deep .testimony-window .v-window__container {
  padding: 8px 0 16px;
}

.slider-item {
  min-width: 340px;
  max-width: 360px;
  flex: 0 0 360px;
  width: 100%;
  padding: 12px;
  display: flex;
}

.testimonial-card {
  width: 100%;
  min-height: 290px;
  border-radius: 32px;
  padding: 32px;
  background: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0.95),
    rgba(230, 250, 247, 0.95)
  );
  box-shadow: 0 25px 60px rgba(9, 49, 86, 0.2);
  position: relative;
  overflow: hidden;
}

.testimonial-card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at top right,
    rgba(255, 138, 0, 0.15),
    transparent 45%
  );
  opacity: 0.8;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  position: relative;
  z-index: 1;
}

.identity {
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.identity:hover {
  transform: translateY(-3px);
}

.name {
  font-weight: 600;
  color: #0b2c5f;
}

.handle {
  font-size: 0.85rem;
  color: rgba(5, 34, 63, 0.6);
}

.rating-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 999px;
  background: linear-gradient(
    120deg,
    rgba(12, 153, 146, 0.14),
    rgba(255, 138, 0, 0.18)
  );
  border: 1px solid rgba(12, 153, 146, 0.4);
  color: #0d4d75;
  font-weight: 600;
  box-shadow: 0 10px 24px rgba(9, 49, 86, 0.15);
  backdrop-filter: blur(6px);
}

.rating-pill .v-icon {
  color: #ff8a00;
}

.quote-mark {
  position: absolute;
  top: 75px;
  left: 32px;
  opacity: 0.4;
  z-index: 0;
}

.quote-mark .v-icon {
  font-size: 90px;
  color: rgba(13, 77, 117, 0.15);
}

.quote-text {
  margin-top: 18px;
  color: #05304d;
  font-size: 1rem;
  line-height: 1.7;
  min-height: 110px;
  text-align: left;
  white-space: normal;
  position: relative;
  z-index: 1;
}

.timestamp {
  font-size: 0.85rem;
  color: rgba(5, 34, 63, 0.6);
  margin-top: 18px;
  position: relative;
  z-index: 1;
}

@media (max-width: 1264px) {
  .slider-shell {
    padding: 18px;
  }
}

@media (max-width: 960px) {
  .trusted-testimony {
    padding: 60px 0 !important;
  }

  .testimony-surface {
    padding: 40px 26px;
  }

  .slider-item {
    min-width: 300px;
    max-width: 320px;
    flex-basis: 320px;
  }

  .testimonial-card {
    padding: 26px;
  }
}

@media (max-width: 600px) {
  .testimony-surface {
    padding: 32px 18px;
  }

  .slider-shell {
    padding: 16px 10px;
  }

  ::v-deep .testimony-slider .v-slide-group__content {
    gap: 12px;
    padding: 8px 0 16px;
  }

  .slider-item {
    min-width: 100%;
    max-width: 100%;
    flex-basis: 100%;
    padding: 8px;
  }

  .testimonial-card {
    padding: 22px;
    border-radius: 24px;
  }

  .card-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .rating-pill {
    align-self: flex-start;
  }

  .quote-mark {
    top: 60px;
    left: 18px;
  }

  .quote-mark .v-icon {
    font-size: 70px;
  }
}
</style>
